module.exports = __webpack_public_path__ + "img/toolbar.b90ec86e.png";